<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <mobile-menu></mobile-menu>
      <template slot="links">

        <component
          v-for="root in menuRootList"
          :is="root.component"
          v-bind="root.props"
        >
          <component
            v-for="item in menuList[root.key]"
            :is="item.component"
            v-bind="item.props"
          >

          </component>
        </component>
      </template>
     
    </side-bar>
     
    <div class="main-panel">
      <!--
      <top-navbar></top-navbar>
      <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>
      -->

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view :key="$route.fullPath"></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

//import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
//import FixedPlugin from "../../FixedPlugin.vue";
//import UserMenu from "./Extra/UserMenu.vue";

import session from "@/kuaa/kuaa-sessions";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";

export default {
  components: {
    //TopNavbar,
    ContentFooter,
    //FixedPlugin,
    //UserMenu,
    MobileMenu
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "kuaa",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      menuRootList : [],
      menuList : {},
      components : []
    };
  },
  created() {
    this.getMenuList();
  },
  methods: {
    getMenuIcon (menuNm){
      let icon = null;
      switch (menuNm) {
        case '교우/임원단관리' :
          icon = 'perm_identity';
          break;
        case '회비관리' :
          icon = 'point_of_sale';
          break;
        case '단체 관리' :
          icon = 'group';
          break;
        case '행사 관리' :
          icon = 'campaign';
          break;
        case '상담 관리' :
          icon = 'local_phone';
          break;
        case '운영 관리' :
          icon = 'web';
          break;
        case '장학 관리' :
          icon = 'school';
          break;
      }
      return icon;
    },

    getMenuList(){
      kuaaApi.sendServer(
        URL_CONST.GET_AUTH_MENU_LIST,
        {},
        "post",
        res => {
          let menuArr = res.data.data.contents;
          let currentRootKey = '';
          menuArr.forEach((item)=>{
            if(item.upperMenuId == 'ROOT'){
              currentRootKey = item.menuNm;
              this.menuList[currentRootKey] = [];

              this.menuRootList.push({
                component : 'sidebar-item',
                props: {                  // 동적 컴포넌트 추가 속성
                  link : { name: currentRootKey, icon: this.getMenuIcon(item.menuNm) }
                },
                key : currentRootKey
              });

            }else{
              this.menuList[currentRootKey].push({
                component : 'sidebar-item',
                props: {                  // 동적 컴포넌트 추가 속성
                  link : {
                    name: item.menuNm,
                    path:  item.menuUrl,
                    target: '_blank'
                  }
                }
              });
            }

          });
          // this.menuList = tempObj;
        }
      );
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    logout () {
      window.location = '/login';
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.sidebar .sidebar-wrapper .nav{
  background-color: #353535;
}
.sidebar .sidebar-wrapper .nav a > span{
  color: #aaa;
}
</style>
